import {
  reorderEventSongs as reorderEventSongsApi
} from "../../../../helpers/event_helper.js";
import { createAsyncThunk } from "@reduxjs/toolkit";


export const reorderEventSongs = createAsyncThunk(
  "eventSongReorder/reorderEventSongs",
  async ({ eventId, songIds }, { rejectWithValue }) => {
    try {
      const response = await reorderEventSongsApi(eventId, songIds);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

